import {
	Card,
	Button,
	Tag,
	Space,
	Typography,
	Row,
	Col,
	Descriptions,
	Divider,
	notification,
	Spin,
	Badge,
	Table,
	Progress,
	List,
	Tabs,
	Collapse,
	Form,
	Input,
	Modal,
	Checkbox,
	Popconfirm,
	Timeline,
	Empty,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
	PiArrowLeftDuotone,
	PiCloudDuotone,
	PiHardDrivesDuotone,
	PiPackageDuotone,
	PiUserDuotone,
	PiReceiptDuotone,
	PiShoppingCartDuotone,
	PiInfoDuotone,
	PiCalendarDuotone,
	PiClockDuotone,
	PiGlobeDuotone,
	PiDatabaseDuotone,
	PiChartBarDuotone,
	PiFileTextDuotone,
	PiRocketLaunchDuotone,
	PiPencilDuotone,
	PiCloudArrowUpDuotone,
	PiArrowDownDuotone,
	PiGearDuotone,
	PiPlusDuotone,
	PiTrashDuotone,
	PiStopDuotone,
	PiPlayDuotone,
	PiArrowClockwiseDuotone,
	PiShuffleDuotone,
} from "react-icons/pi";
import { requestShowInstance, requestShowWEHOAccountDetails } from "../../services/user.service";
import dayjs from "dayjs";
import { formatCurrency } from "../../utils/Formatter";
import {
	CheckCircleOutlined,
	ClockCircleOutlined,
	CloseCircleOutlined,
	CodeOutlined,
} from "@ant-design/icons";
import {
	requestUpdateAPLAApplication,
	requestGetAPLAApplicationLogs,
	requestGetAPLAApplicationDeployments,
	requestCreateAPLAApplicationEnvironment,
	requestUpdateAPLAApplicationEnvironment,
	requestDeleteAPLAApplicationEnvironment,
	requestGetAPLAApplicationEnvironments,
	requestShowAPLAApplication,
	requestUpdateAPLAApplicationDomains,
	requestRedeployAPLAApplication,
	requestRestartAPLAApplication,
	requestStopAPLAApplication,
} from "../../services/apla.service";

const { Title, Text } = Typography;

function InstanceViewPage() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const { teamId, id } = useParams();
	const [loading, setLoading] = useState(false);
	const [instance, setInstance] = useState(null);
	const [suspendLoading, setSuspendLoading] = useState(false);
	const [terminateLoading, setTerminateLoading] = useState(false);
	const [activeTabKey, setActiveTabKey] = useState(searchParams.get("tab") || "overview");
	const [aplaLogs, setAplaLogs] = useState(null);
	const aplaLogsRef = useRef(null);
	const [aplaEnvironments, setAplaEnvironments] = useState([]);
	const [aplaDeployments, setAplaDeployments] = useState([]);

	// General Info Update
	const [aplaApplication, setAplaApplication] = useState(null);
	const [updateGeneralInfoLoading, setUpdateGeneralInfoLoading] = useState(false);
	const [generalAPLAInfoForm] = Form.useForm();

	// APLA Application State
	const [aplaRedeploying, setAplaRedeploying] = useState(false);
	const [aplaStarting, setAplaStarting] = useState(false);
	const [aplaRestarting, setAplaRestarting] = useState(false);
	const [aplaStopping, setAplaStopping] = useState(false);

	// Domains
	const [aplaDomains, setAplaDomains] = useState([]);
	const [updateDomainsLoading, setUpdateDomainsLoading] = useState(false);
	const [domainForm] = Form.useForm();
	const [addDomainModalVisible, setAddDomainModalVisible] = useState(false);

	// Metadata Edit Modal
	const [editMetadataModalVisible, setEditMetadataModalVisible] = useState(false);
	const [editMetadataLoading, setEditMetadataLoading] = useState(false);
	const [metadataForm] = Form.useForm();

	// Create Environment Modal
	const [createEnvironmentModalVisible, setCreateEnvironmentModalVisible] = useState(false);
	const [createEnvironmentLoading, setCreateEnvironmentLoading] = useState(false);
	const [createEnvironmentForm] = Form.useForm();

	// WEHO Account
	const [wehoAccount, setWehoAccount] = useState(null);

	useEffect(() => {
		document.title = "Cloudiva App | Detail Instansi";
		fetchInstanceDetails();
	}, [id]);

	useEffect(() => {
		if (
			activeTabKey == "logs" &&
			instance &&
			instance.type === "APLA" &&
			instance.metadata?.aplaApplicationId
		) {
			fetchAPLAApplicationLogs(instance.metadata.aplaApplicationId);
		}
	}, [instance, activeTabKey]);

	useEffect(() => {
		if (activeTabKey === "logs" && aplaLogs && aplaLogsRef.current) {
			aplaLogsRef.current?.scrollTo({ top: aplaLogsRef.current.scrollHeight, behavior: "smooth" });
		}
	}, [aplaLogs, activeTabKey, aplaLogsRef.current]);

	const fetchInstanceDetails = () => {
		setLoading(true);
		requestShowInstance(teamId, id)
			.then((response) => {
				const instanceData = response.data.data || response.data;
				setInstance(instanceData);

				if (instanceData.type === "WEHO" && instanceData.metadata?.wehoAccountId) {
					fetchInstanceWEHOAccount(instanceData.metadata.wehoAccountId);
				}

				if (instanceData.type === "APLA" && instanceData.metadata?.aplaApplicationId) {
					fetchAPLAApplicationDetails(instanceData.metadata.aplaApplicationId);
					fetchAPLAApplicationDeployments(instanceData.metadata.aplaApplicationId);
					fetchAPLAApplicationEnvironments(instanceData.metadata.aplaApplicationId);
				}
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: "Gagal mengambil detail layanan",
				});
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const fetchInstanceWEHOAccount = (id) => {
		requestShowWEHOAccountDetails(teamId, id)
			.then((response) => {
				setWehoAccount(response.data.data || response.data);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: "Gagal mengambil detail akun WEHO",
				});
			});
	};

	const fetchAPLAApplicationDetails = (id) => {
		requestShowAPLAApplication(teamId, id)
			.then((response) => {
				const aplaApplication = response.data.data;
				setAplaApplication(aplaApplication);

				const fqdn = aplaApplication.metadata.fqdn;
				if (fqdn && fqdn.length > 0) {
					setAplaDomains(fqdn.split(","));
				}

				generalAPLAInfoForm.setFieldsValue({
					name: aplaApplication.name,
					description: aplaApplication.description,
				});
			})
			.catch((error) => {
				notification.error({
					message: "Error",
					description: "Failed to fetch APLA application details",
				});
			});
	};

	const fetchAPLAApplicationLogs = (id) => {
		requestGetAPLAApplicationLogs(teamId, id)
			.then((response) => {
				setAplaLogs(response.data.data);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: "Gagal mengambil log aplikasi APLA",
				});
			});
	};

	const fetchAPLAApplicationDeployments = (id) => {
		requestGetAPLAApplicationDeployments(teamId, id)
			.then((response) => {
				setAplaDeployments(response.data.data);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: "Gagal mengambil deployment aplikasi APLA",
				});
			});
	};

	const fetchAPLAApplicationEnvironments = (id) => {
		requestGetAPLAApplicationEnvironments(teamId, id)
			.then((response) => {
				setAplaEnvironments(response.data.data);
			})
			.catch((error) => {
				console.error(error);
				notification.error({
					message: "Error",
					description:
						error.response?.data?.message || "Failed to fetch APLA application environments",
				});
			});
	};

	const handleEnvironmentChange = (uuid, field, value) => {
		setAplaEnvironments((prevEnvs) =>
			prevEnvs.map((env) => (env.uuid === uuid ? { ...env, [field]: value } : env))
		);
	};

	const handleUpdateEnvironmentSubmit = () => {
		requestUpdateAPLAApplicationEnvironment(teamId, instance.metadata.aplaApplicationId, {
			environments: aplaEnvironments,
		})
			.then(() => {
				notification.success({
					message: "Berhasil",
					description: "Environment aplikasi berhasil diperbarui",
				});
				// Refresh environments
				fetchAPLAApplicationEnvironments(instance.metadata.aplaApplicationId);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: error.response?.data?.message || "Gagal memperbarui lingkungan aplikasi",
				});
			});
	};

	const handleCreateEnvironment = () => {
		setCreateEnvironmentModalVisible(true);
		createEnvironmentForm.resetFields();
	};

	const handleCreateEnvironmentSubmit = (values) => {
		setCreateEnvironmentLoading(true);
		requestCreateAPLAApplicationEnvironment(teamId, instance.metadata.aplaApplicationId, {
			...values,
			isPreview: values.isPreview || false,
		})
			.then(() => {
				notification.success({
					message: "Berhasil",
					description: "Variabel lingkungan berhasil dibuat",
				});
				setCreateEnvironmentModalVisible(false);
				createEnvironmentForm.resetFields();
				// Refresh environments
				fetchAPLAApplicationEnvironments(instance.metadata.aplaApplicationId);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: error.response?.data?.message || "Gagal membuat variabel lingkungan",
				});
			})
			.finally(() => {
				setCreateEnvironmentLoading(false);
			});
	};

	const handleCreateEnvironmentCancel = () => {
		setCreateEnvironmentModalVisible(false);
		createEnvironmentForm.resetFields();
	};

	const handleDeleteEnvironmentSubmit = (envId) => {
		requestDeleteAPLAApplicationEnvironment(teamId, instance.metadata.aplaApplicationId, envId)
			.then(() => {
				notification.success({
					message: "Berhasil",
					description: "Variabel lingkungan berhasil dihapus",
				});
				// Refresh environments
				fetchAPLAApplicationEnvironments(instance.metadata.aplaApplicationId);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: error.response?.data?.message || "Gagal menghapus variabel lingkungan",
				});
			});
	};

	const handleUpdateAPLAApplication = () => {
		generalAPLAInfoForm
			.validateFields()
			.then((values) => {
				setUpdateGeneralInfoLoading(true);
				requestUpdateAPLAApplication(teamId, instance.metadata.aplaApplicationId, {
					name: values.name,
					description: values.description,
				})
					.then((response) => {
						notification.success({
							message: "Berhasil",
							description: "Aplikasi berhasil diperbarui",
						});
					})
					.catch((error) => {
						notification.error({
							message: "Kesalahan",
							description: error.response?.data?.message || "Gagal memperbarui aplikasi",
						});
					});
			})
			.catch((info) => {});
	};

	// Domain Management Functions
	const handleAddDomain = () => {
		domainForm
			.validateFields()
			.then((values) => {
				const newDomain = values.domain.trim();

				// Ensure domain starts with https://
				const formattedDomain = newDomain.startsWith("https://")
					? newDomain
					: `https://${newDomain}`;

				const updatedDomains = [...aplaDomains, formattedDomain];
				setUpdateDomainsLoading(true);

				requestUpdateAPLAApplicationDomains(teamId, instance.metadata.aplaApplicationId, {
					domains: updatedDomains,
				})
					.then((response) => {
						notification.success({
							message: "Berhasil",
							description: "Domain berhasil ditambahkan",
						});
						setAplaDomains(updatedDomains);
						setAddDomainModalVisible(false);
						domainForm.resetFields();
					})
					.catch((error) => {
						notification.error({
							message: "Kesalahan",
							description: error.response?.data?.message || "Gagal menambahkan domain",
						});
					})
					.finally(() => {
						setUpdateDomainsLoading(false);
					});
			})
			.catch((info) => {});
	};

	const handleRemoveDomain = (domainToRemove) => {
		const updatedDomains = aplaDomains.filter((domain) => domain !== domainToRemove);
		setUpdateDomainsLoading(true);

		requestUpdateAPLAApplicationDomains(teamId, instance.metadata.aplaApplicationId, {
			domains: updatedDomains,
		})
			.then((response) => {
				notification.success({
					message: "Berhasil",
					description: "Domain berhasil dihapus",
				});
				setAplaDomains(updatedDomains);
			})
			.catch((error) => {
				notification.error({
					message: "Kesalahan",
					description: error.response?.data?.message || "Gagal menghapus domain",
				});
			})
			.finally(() => {
				setUpdateDomainsLoading(false);
			});
	};

	const getStatusColor = (status) => {
		switch (status) {
			case "PENDING":
				return "orange";
			case "PROVISIONING":
				return "processing";
			case "RUNNING":
			case "ACTIVE":
				return "green";
			case "SUSPENDED":
				return "red";
			case "CANCELLED":
				return "volcano";
			case "TERMINATED":
				return "default";
			default:
				return "blue";
		}
	};

	const getStatusText = (status) => {
		switch (status) {
			case "PENDING":
				return "Menunggu";
			case "PROVISIONING":
				return "Menyiapkan";
			case "RUNNING":
				return "Berjalan";
			case "ACTIVE":
				return "Aktif";
			case "SUSPENDED":
				return "Ditangguhkan";
			case "CANCELLED":
				return "Dibatalkan";
			case "TERMINATED":
				return "Dihentikan";
			default:
				return status;
		}
	};

	if (loading) {
		return (
			<div className="page-content">
				<div style={{ textAlign: "center", padding: "50px 0" }}>
					<Spin size="large" />
				</div>
			</div>
		);
	}

	if (!instance) {
		return (
			<div className="page-content">
				<div style={{ textAlign: "center", padding: "50px 0" }}>
					<Text>Instansi tidak ditemukan</Text>
				</div>
			</div>
		);
	}

	return (
		<div className="page-content">
			<div style={{ marginBottom: 24 }}>
				<Space split={<Divider type="vertical" />}>
					<Space>
						<Button
							icon={<PiArrowLeftDuotone />}
							onClick={() => navigate(`/${teamId}/instances`)}
						/>
						<Title level={4} style={{ margin: 0 }}>
							Detail Layanan
						</Title>
						<Tag color={getStatusColor(instance.status)}>{getStatusText(instance.status)}</Tag>
					</Space>
				</Space>
			</div>

			<div className="page-content-wrapper">
				<Row gutter={24}>
					{/* Main Content */}
					<Col span={24}>
						{/* Tabs for organized content */}
						<Tabs
							defaultActiveKey={activeTabKey}
							type="card"
							style={{ marginBottom: 24 }}
							onChange={(activeKey) => {
								setActiveTabKey(activeKey);
								setSearchParams({ tab: activeKey });
							}}
							tabBarExtraContent={
								<Space>
									{instance.type === "APLA" && aplaApplication?.metadata && (
										<>
											{aplaApplication.metadata.status.split(":")[0] !== "running" ? (
												<>
													<Button
														type="primary"
														loading={aplaRedeploying}
														icon={<PiRocketLaunchDuotone />}
														onClick={() => {
															setAplaRedeploying(true);
															requestRedeployAPLAApplication(
																teamId,
																instance.metadata.aplaApplicationId
															)
																.then(() => {
																	notification.success({
																		message: "Berhasil",
																		description:
																			"Deployment dalam proses, lihat tab Deployment untuk melihat detailnya",
																	});
																})
																.catch((error) => {
																	notification.error({
																		message: "Kesalahan",
																		description:
																			error.response?.data?.message || "Gagal mendeploy aplikasi",
																	});
																})
																.finally(() => {
																	setAplaRedeploying(false);
																});
														}}>
														Deploy
													</Button>
												</>
											) : (
												<>
													<Button
														type="dashed"
														loading={aplaRestarting}
														icon={<PiArrowClockwiseDuotone />}
														onClick={() => {
															setAplaRestarting(true);
															requestRestartAPLAApplication(
																teamId,
																instance.metadata.aplaApplicationId
															)
																.then(() => {
																	notification.success({
																		message: "Berhasil",
																		description: "APLA Application berhasil direstart",
																	});
																})
																.catch((error) => {
																	notification.error({
																		message: "Kesalahan",
																		description:
																			error.response?.data?.message ||
																			"Gagal merestart APLA Application",
																	});
																})
																.finally(() => {
																	setAplaRestarting(false);
																});
														}}>
														Restart
													</Button>
													<Button
														loading={aplaRedeploying}
														icon={<PiShuffleDuotone />}
														onClick={() => {
															setAplaRedeploying(true);
															requestRedeployAPLAApplication(
																teamId,
																instance.metadata.aplaApplicationId
															)
																.then(() => {
																	notification.success({
																		message: "Berhasil",
																		description: "APLA Application berhasil dideploy ulang",
																	});
																})
																.catch((error) => {
																	notification.error({
																		message: "Kesalahan",
																		description:
																			error.response?.data?.message ||
																			"Gagal mendeploy ulang APLA Application",
																	});
																})
																.finally(() => {
																	setAplaRedeploying(false);
																});
														}}>
														Redeploy
													</Button>
													<Button
														danger
														loading={aplaStopping}
														icon={<PiStopDuotone />}
														onClick={() => {
															setAplaStopping(true);
															requestStopAPLAApplication(
																teamId,
																instance.metadata.aplaApplicationId
															)
																.then(() => {
																	notification.success({
																		message: "Berhasil",
																		description: "APLA Application berhasil dihentikan",
																	});
																})
																.catch((error) => {
																	notification.error({
																		message: "Kesalahan",
																		description:
																			error.response?.data?.message ||
																			"Gagal menghentikan APLA Application",
																	});
																})
																.finally(() => {
																	setAplaStopping(false);
																});
														}}>
														Stop
													</Button>
												</>
											)}
										</>
									)}
								</Space>
							}
							items={[
								{
									key: "overview",
									label: (
										<Space>
											<PiInfoDuotone />
											Ikhtisar
										</Space>
									),
									children: (
										<Row gutter={24}>
											<Col span={16}>
												<Card
													type="inner"
													title={"Detail"}
													extra={
														<Space>
															{/* {(instance.status === "ACTIVE" ||
																instance.status === "SUSPENDED") && (
																<Popconfirm
																	title="Terminate Instance"
																	description="This action cannot be undone. Are you sure you want to terminate this instance?"
																	onConfirm={handleTerminateInstance}
																	okText="Yes, Terminate"
																	cancelText="Cancel">
																	<Button
																		type="primary"
																		danger
																		icon={<PiTrashDuotone />}
																		loading={terminateLoading}>
																		Terminate
																	</Button>
																</Popconfirm>
															)} */}
														</Space>
													}
													style={{ marginBottom: 24 }}>
													<Descriptions column={2} bordered size="small">
														<Descriptions.Item label="Nomor Seri" span={1}>
															<Text strong copyable>
																{instance.number}
															</Text>
														</Descriptions.Item>
														<Descriptions.Item label="Status" span={1}>
															<Tag color={getStatusColor(instance.status)}>
																{getStatusText(instance.status)}
															</Tag>
														</Descriptions.Item>
														<Descriptions.Item label="Tipe" span={1}>
															<Tag color="blue">{instance.type}</Tag>
														</Descriptions.Item>
														<Descriptions.Item label="ID Instansi" span={1}>
															<Text code copyable>
																{instance._id}
															</Text>
														</Descriptions.Item>
														<Descriptions.Item label="Tanggal Dibuat" span={1}>
															<Space>
																<PiCalendarDuotone />
																{dayjs(instance.createdAt).format("DD MMMM YYYY, HH:mm")}
															</Space>
														</Descriptions.Item>
														<Descriptions.Item label="Terakhir Diperbarui" span={1}>
															<Space>
																<PiCalendarDuotone />
																{dayjs(instance.updatedAt).format("DD MMMM YYYY, HH:mm")}
															</Space>
														</Descriptions.Item>
														{instance.expiredAt && (
															<Descriptions.Item label="Tanggal Kedaluwarsa" span={1}>
																<Space>
																	<PiCalendarDuotone />
																	{dayjs(instance.expiredAt).format("DD MMMM YYYY, HH:mm")}
																</Space>
															</Descriptions.Item>
														)}
														{instance.nextBilledAt && (
															<Descriptions.Item label="Penagihan Berikutnya" span={1}>
																<Space>
																	<PiCalendarDuotone />
																	{dayjs(instance.nextBilledAt).format("DD MMMM YYYY, HH:mm")}
																</Space>
															</Descriptions.Item>
														)}
														{instance.cycle && (
															<Descriptions.Item label="Siklus Penagihan" span={2}>
																<Space>
																	<PiClockDuotone />
																	<Text strong>
																		{instance.cycle.amount} {instance.cycle.interval}
																	</Text>
																</Space>
															</Descriptions.Item>
														)}
														{instance.type === "WEHO" && (
															<Descriptions.Item label="Domain" span={2}>
																<Space>
																	<PiGlobeDuotone />
																	<Text
																		editable={{
																			onChange: (value) => {
																				// show confirmation
																				Modal.confirm({
																					title: "Konfirmasi Perubahan Domain",
																					content: `Apakah Anda yakin ingin mengubah domain menjadi ${value}?`,
																					onOk: () => {
																						setEditMetadataLoading(true);

																						requestUpdateInstanceMetadata(id, {
																							domain: value,
																						})
																							.then((response) => {
																								if (response.data.code === 200) {
																									notification.success({
																										message: "Berhasil",
																										description:
																											"Metadata layanan berhasil diperbarui",
																									});
																									setEditMetadataModalVisible(false);
																									metadataForm.resetFields();
																									fetchInstanceDetails(); // Refresh the data
																								} else {
																									notification.error({
																										message: "Kesalahan",
																										description:
																											response.data.message ||
																											"Gagal memperbarui metadata layanan",
																									});
																								}
																							})
																							.catch((error) => {
																								notification.error({
																									message: "Kesalahan",
																									description:
																										error.response?.data?.message ||
																										"Gagal memperbarui metadata layanan",
																								});
																							})
																							.finally(() => {
																								setEditMetadataLoading(false);
																							});
																					},
																				});
																			},
																		}}
																		strong>
																		{instance.metadata?.domain}
																	</Text>
																</Space>
															</Descriptions.Item>
														)}
													</Descriptions>
												</Card>
												<Row gutter={24}>
													<Col span={12}>
														<Card type="inner" title={"Layanan"}>
															<div style={{ marginBottom: 16 }}>
																<Text strong style={{ display: "block", marginBottom: 8 }}>
																	{instance.service?.name}
																</Text>
																<div style={{ marginBottom: 8 }}>
																	<Text type="secondary">Kode: </Text>
																	<Tag>{instance.service?.code}</Tag>
																</div>
																<div style={{ marginBottom: 8 }}>
																	<Text type="secondary">Status: </Text>
																	<Tag color="green">{instance.service?.status}</Tag>
																</div>
																<div>
																	<Text type="secondary">Deskripsi: </Text>
																	<Text>
																		{instance.service?.description || "Tidak ada deskripsi"}
																	</Text>
																</div>
															</div>
															{instance.service?.features &&
																instance.service.features.length > 0 && (
																	<div>
																		<Text strong style={{ display: "block", marginBottom: 8 }}>
																			Fitur:
																		</Text>
																		<Space wrap>
																			{instance.service.features.map((feature) => (
																				<Tag key={feature._id} color="blue">
																					{feature.name}
																				</Tag>
																			))}
																		</Space>
																	</div>
																)}
														</Card>
													</Col>
													<Col span={12}>
														<Card type="inner" title={"Paket"}>
															<div style={{ marginBottom: 16 }}>
																<Text strong style={{ display: "block", marginBottom: 8 }}>
																	{instance.plan?.name}
																</Text>
																<div style={{ marginBottom: 8 }}>
																	<Text type="secondary">Kode: </Text>
																	<Tag>{instance.plan?.code}</Tag>
																</div>
																<div style={{ marginBottom: 8 }}>
																	<Text type="secondary">Status: </Text>
																	<Tag color="green">{instance.plan?.status}</Tag>
																</div>
																<div>
																	<Text type="secondary">Deskripsi: </Text>
																	<Text>{instance.plan?.description || "Tidak ada deskripsi"}</Text>
																</div>
															</div>
															{instance.plan?.price && (
																<div>
																	<Text strong style={{ display: "block", marginBottom: 8 }}>
																		Harga:
																	</Text>
																	<div
																		style={{ fontSize: "16px", fontWeight: 600, color: "#1890ff" }}>
																		{formatCurrency(instance.plan.price.amount)} /{" "}
																		{instance.plan.price.unit} / {instance.plan.price.interval}
																	</div>
																</div>
															)}
														</Card>
													</Col>
												</Row>
											</Col>
											<Col span={8}>
												<Card type="inner" title={"Penanda Waktu"} style={{ marginBottom: 24 }}>
													<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
														<div style={{ display: "flex", justifyContent: "space-between" }}>
															<Text type="secondary">Dibuat:</Text>
															<Text>{dayjs(instance.createdAt).format("DD MMM YYYY, HH:mm")}</Text>
														</div>
														<div style={{ display: "flex", justifyContent: "space-between" }}>
															<Text type="secondary">Diperbarui:</Text>
															<Text>{dayjs(instance.updatedAt).format("DD MMM YYYY, HH:mm")}</Text>
														</div>
														{instance.expiredAt && (
															<div style={{ display: "flex", justifyContent: "space-between" }}>
																<Text type="secondary">Kedaluwarsa:</Text>
																<Text
																	style={{
																		color: dayjs(instance.expiredAt).isBefore(dayjs())
																			? "#ff4d4f"
																			: "inherit",
																	}}>
																	{dayjs(instance.expiredAt).format("DD MMM YYYY, HH:mm")}
																</Text>
															</div>
														)}
														{instance.nextBilledAt && (
															<div style={{ display: "flex", justifyContent: "space-between" }}>
																<Text type="secondary">Tagihan Berikutnya:</Text>
																<Text>
																	{dayjs(instance.nextBilledAt).format("DD MMM YYYY, HH:mm")}
																</Text>
															</div>
														)}
														<div style={{ display: "flex", justifyContent: "space-between" }}>
															<Text type="secondary">Usia:</Text>
															<Text>{dayjs(instance.createdAt).fromNow()}</Text>
														</div>
													</div>
												</Card>
												<Row gutter={16}>
													{instance.orderId && (
														<Col span={12}>
															<Card type="inner" size="small">
																<div style={{ textAlign: "center" }}>
																	<PiShoppingCartDuotone
																		size={24}
																		style={{ color: "#1890ff", marginBottom: 8 }}
																	/>
																	<div style={{ marginBottom: 8 }}>
																		<Text strong>Pesanan Terkait</Text>
																	</div>
																	<Button
																		type="primary"
																		onClick={() =>
																			navigate(`/${teamId}/orders/${instance.orderId}`)
																		}>
																		Lihat Pesanan
																	</Button>
																</div>
															</Card>
														</Col>
													)}
													{instance.invoiceId && (
														<Col span={12}>
															<Card type="inner" size="small">
																<div style={{ textAlign: "center" }}>
																	<PiReceiptDuotone
																		size={24}
																		style={{ color: "#52c41a", marginBottom: 8 }}
																	/>
																	<div style={{ marginBottom: 8 }}>
																		<Text strong>Tagihan Terkait</Text>
																	</div>
																	<Button
																		type="primary"
																		onClick={() =>
																			navigate(`/${teamId}/invoices/${instance.invoiceId}`)
																		}>
																		Lihat Tagihan
																	</Button>
																</div>
															</Card>
														</Col>
													)}
												</Row>
											</Col>
										</Row>
									),
								},
								instance &&
									instance.type === "WEHO" && {
										key: "account",
										label: (
											<Space>
												<PiUserDuotone />
												Akun
											</Space>
										),
										children:
											wehoAccount &&
											(wehoAccount.metadata?.account_info || wehoAccount.metadata?.resource) ? (
												<Row gutter={24}>
													<Col span={12}>
														<Card title={"Detail"} type="inner" style={{ marginBottom: 24 }}>
															<Descriptions size="small" column={1} bordered>
																{wehoAccount.metadata?.user && (
																	<Descriptions.Item label="Nama Pengguna">
																		<Text code>{wehoAccount.metadata.user}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.domain && (
																	<Descriptions.Item label="Domain">
																		<Text code copyable>
																			{wehoAccount.metadata.domain}
																		</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.email && (
																	<Descriptions.Item label="Email">
																		<Text>{wehoAccount.metadata.email}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.homedir && (
																	<Descriptions.Item label="Direktori Home">
																		<Text code>{wehoAccount.metadata.homedir}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.plan && (
																	<Descriptions.Item label="Paket">
																		<Text
																			style={{
																				textTransform: "uppercase",
																			}}>
																			{wehoAccount.metadata.plan}
																		</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.created && (
																	<Descriptions.Item label="Dibuat">
																		<Text>
																			{dayjs
																				.unix(wehoAccount.metadata.created)
																				.format("DD MMMM YYYY, HH:mm")}
																		</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.ip && (
																	<Descriptions.Item label="Alamat IP">
																		<Text code>{wehoAccount.metadata.ip}</Text>
																	</Descriptions.Item>
																)}
																{/* CWP Format Details */}
																{wehoAccount.metadata?.account_info?.directory && (
																	<Descriptions.Item label="Direktori">
																		<Text code>{wehoAccount.metadata.account_info.directory}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.account_info?.email && (
																	<Descriptions.Item label="Email">
																		<Text>{wehoAccount.metadata.account_info.email}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.account_info?.package_name && (
																	<Descriptions.Item label="Nama Paket">
																		<Text>{wehoAccount.metadata.account_info.package_name}</Text>
																	</Descriptions.Item>
																)}
																{wehoAccount.metadata?.account_info?.state && (
																	<Descriptions.Item label="Status Akun">
																		<Tag
																			color={
																				wehoAccount.metadata.account_info.state === "active"
																					? "green"
																					: "red"
																			}>
																			{wehoAccount.metadata.account_info.state}
																		</Tag>
																	</Descriptions.Item>
																)}
															</Descriptions>
															<div
																style={{
																	marginTop: 16,
																	width: "100%",
																	display: "flex",
																	justifyContent: "flex-end",
																}}>
																<Button
																	style={{ width: "100%" }}
																	type="primary"
																	onClick={() => {
																		window.open(
																			`https://${wehoAccount.server.hostname}:2003`,
																			"_blank"
																		);
																	}}>
																	Login ke Panel
																</Button>
															</div>
														</Card>
														<Card title={"Penggunaan"} type="inner">
															{/* Storage Usage - Handle both CWP and WEBUZO */}
															<div style={{ marginBottom: 24 }}>
																<div
																	style={{
																		display: "flex",
																		justifyContent: "space-between",
																		marginBottom: 8,
																	}}>
																	<Text strong>Ruang Disk</Text>
																	<Text type="secondary">
																		{wehoAccount.metadata?.resource?.disk ? (
																			// WEBUZO format
																			<>
																				{wehoAccount.metadata.resource.disk.used} /{" "}
																				{wehoAccount.metadata.resource.disk.limit === "0B"
																					? "∞"
																					: wehoAccount.metadata.resource.disk.limit}
																			</>
																		) : (
																			// CWP format
																			<>
																				{wehoAccount.metadata?.account_info?.space_usage?.toFixed(
																					2
																				) || 0}{" "}
																				MB /{" "}
																				{wehoAccount.metadata?.account_info?.space_disk ===
																				"unlimited"
																					? "∞"
																					: `${wehoAccount.metadata?.account_info?.space_disk} MB`}
																			</>
																		)}
																	</Text>
																</div>
																<Progress
																	percent={
																		wehoAccount.metadata?.resource?.disk
																			? // WEBUZO format
																			  wehoAccount.metadata.resource.disk.percent
																			: // CWP format
																			wehoAccount.metadata?.account_info?.space_disk === "unlimited"
																			? 0
																			: ((wehoAccount.metadata?.account_info?.space_usage || 0) /
																					parseFloat(
																						wehoAccount.metadata?.account_info?.space_disk
																					)) *
																			  100
																	}
																	showInfo={false}
																	status={
																		wehoAccount.metadata?.resource?.disk
																			? // WEBUZO format
																			  wehoAccount.metadata.resource.disk.percent > 80
																				? "exception"
																				: "normal"
																			: // CWP format
																			wehoAccount.metadata?.account_info?.space_disk === "unlimited"
																			? "normal"
																			: ((wehoAccount.metadata?.account_info?.space_usage || 0) /
																					parseFloat(
																						wehoAccount.metadata?.account_info?.space_disk
																					)) *
																					100 >
																			  80
																			? "exception"
																			: "normal"
																	}
																	strokeColor="#1890ff"
																/>
															</div>

															{/* Bandwidth Usage - Handle both CWP and WEBUZO */}
															<div style={{ marginBottom: 24 }}>
																<div
																	style={{
																		display: "flex",
																		justifyContent: "space-between",
																		marginBottom: 8,
																	}}>
																	<Text strong>Bandwidth</Text>
																	<Text type="secondary">
																		{wehoAccount.metadata?.resource?.bandwidth ? (
																			// WEBUZO format
																			<>
																				{wehoAccount.metadata.resource.bandwidth.used} /{" "}
																				{wehoAccount.metadata.resource.bandwidth.limit ===
																				"unlimited"
																					? "∞"
																					: wehoAccount.metadata.resource.bandwidth.limit}
																			</>
																		) : (
																			// CWP format
																			<>
																				{wehoAccount.metadata?.account_info?.bandwidth_used || 0} MB
																				/ {wehoAccount.metadata?.account_info?.bandwidth || 0} MB
																			</>
																		)}
																	</Text>
																</div>
																<Progress
																	percent={
																		wehoAccount.metadata?.resource?.bandwidth
																			? // WEBUZO format
																			  wehoAccount.metadata.resource.bandwidth.percent
																			: // CWP format
																			parseFloat(wehoAccount.metadata?.account_info?.bandwidth) > 0
																			? ((parseFloat(
																					wehoAccount.metadata?.account_info?.bandwidth_used
																			  ) || 0) /
																					parseFloat(
																						wehoAccount.metadata?.account_info?.bandwidth
																					)) *
																			  100
																			: 0
																	}
																	showInfo={false}
																	status={
																		wehoAccount.metadata?.resource?.bandwidth
																			? // WEBUZO format
																			  wehoAccount.metadata.resource.bandwidth.percent > 80
																				? "exception"
																				: "normal"
																			: // CWP format
																			parseFloat(wehoAccount.metadata?.account_info?.bandwidth) >
																					0 &&
																			  ((parseFloat(
																					wehoAccount.metadata?.account_info?.bandwidth_used
																			  ) || 0) /
																					parseFloat(
																						wehoAccount.metadata?.account_info?.bandwidth
																					)) *
																					100 >
																					80
																			? "exception"
																			: "normal"
																	}
																	strokeColor="#52c41a"
																/>
															</div>
															<Divider />
															{/* Account Statistics - Handle both CWP and WEBUZO */}
															<Row gutter={16}>
																<Col span={8}>
																	<Space direction="vertical">
																		<Text strong>Akun FTP</Text>
																		<Progress
																			style={{ marginTop: 8 }}
																			type="circle"
																			percent={
																				wehoAccount.metadata?.resource?.ftp
																					? // WEBUZO format
																					  wehoAccount.metadata.resource.ftp.percent
																					: // CWP format
																					wehoAccount.metadata?.account_info?.ftp_accounts_used
																					? (wehoAccount.metadata.account_info.ftp_accounts_used /
																							wehoAccount.metadata.account_info.ftp_accounts) *
																					  100
																					: 0
																			}
																			format={(percent) =>
																				wehoAccount.metadata?.resource?.ftp
																					? // WEBUZO format
																					  `${wehoAccount.metadata.resource.ftp.used} / ${
																							wehoAccount.metadata.resource.ftp.limit ===
																							"unlimited"
																								? "∞"
																								: wehoAccount.metadata.resource.ftp.limit
																					  }`
																					: // CWP format
																					  `${
																							wehoAccount.metadata?.account_info
																								?.ftp_accounts_used || 0
																					  } / ${
																							wehoAccount.metadata?.account_info?.ftp_accounts || 0
																					  }`
																			}
																		/>
																	</Space>
																</Col>
																<Col span={8}>
																	<Space direction="vertical">
																		<Text strong>Akun Email</Text>
																		<Progress
																			type="circle"
																			percent={
																				wehoAccount.metadata?.resource?.email_account
																					? // WEBUZO format
																					  wehoAccount.metadata.resource.email_account.percent
																					: // CWP format
																					wehoAccount.metadata?.account_info?.email_accounts_used
																					? (wehoAccount.metadata.account_info.email_accounts_used /
																							wehoAccount.metadata.account_info.email_accounts) *
																					  100
																					: 0
																			}
																			format={(percent) =>
																				wehoAccount.metadata?.resource?.email_account
																					? // WEBUZO format
																					  `${
																							wehoAccount.metadata.resource.email_account.used
																					  } / ${
																							wehoAccount.metadata.resource.email_account.limit ===
																							"unlimited"
																								? "∞"
																								: wehoAccount.metadata.resource.email_account.limit
																					  }`
																					: // CWP format
																					  `${
																							wehoAccount.metadata?.account_info
																								?.email_accounts_used || 0
																					  } / ${
																							wehoAccount.metadata?.account_info?.email_accounts ||
																							0
																					  }`
																			}
																		/>
																	</Space>
																</Col>
																<Col span={8}>
																	<Space direction="vertical">
																		<Text strong>Basis Data</Text>
																		<Progress
																			type="circle"
																			percent={
																				wehoAccount.metadata?.resource?.db
																					? // WEBUZO format
																					  wehoAccount.metadata.resource.db.percent
																					: // CWP format
																					wehoAccount.metadata?.account_info?.db_used
																					? (wehoAccount.metadata.account_info.db_used /
																							wehoAccount.metadata.account_info.db_max) *
																					  100
																					: 0
																			}
																			format={(percent) =>
																				wehoAccount.metadata?.resource?.db
																					? // WEBUZO format
																					  `${wehoAccount.metadata.resource.db.used} / ${
																							wehoAccount.metadata.resource.db.limit === "unlimited"
																								? "∞"
																								: wehoAccount.metadata.resource.db.limit
																					  }`
																					: // CWP format
																					  `${
																							wehoAccount.metadata?.account_info?.db_used || 0
																					  } / ${wehoAccount.metadata?.account_info?.db_max || 0}`
																			}
																		/>
																	</Space>
																</Col>
															</Row>
															<Divider />
															<Row gutter={16}>
																<Col span={8}>
																	<Space direction="vertical">
																		<Text strong>Addon Domains</Text>
																		<Progress
																			type="circle"
																			percent={
																				wehoAccount.metadata?.resource?.addondom
																					? // WEBUZO format
																					  wehoAccount.metadata.resource.addondom.percent
																					: // CWP format
																					wehoAccount.metadata?.account_info?.addons_domains_used
																					? (wehoAccount.metadata.account_info.addons_domains_used /
																							wehoAccount.metadata.account_info.addons_domains) *
																					  100
																					: 0
																			}
																			format={(percent) =>
																				wehoAccount.metadata?.resource?.addondom
																					? // WEBUZO format
																					  `${wehoAccount.metadata.resource.addondom.used} / ${
																							wehoAccount.metadata.resource.addondom.limit ===
																							"unlimited"
																								? "∞"
																								: wehoAccount.metadata.resource.addondom.limit
																					  }`
																					: // CWP format
																					  `${
																							wehoAccount.metadata?.account_info
																								?.addons_domains_used || 0
																					  } / ${
																							wehoAccount.metadata?.account_info?.addons_domains ||
																							0
																					  }`
																			}
																		/>
																	</Space>
																</Col>
																<Col span={8}>
																	<Space direction="vertical">
																		<Text strong>Sub Domains</Text>
																		<Progress
																			type="circle"
																			percent={
																				wehoAccount.metadata?.resource?.subdom
																					? // WEBUZO format
																					  wehoAccount.metadata.resource.subdom.percent
																					: // CWP format
																					wehoAccount.metadata?.account_info?.sub_domains_used
																					? (wehoAccount.metadata.account_info.sub_domains_used /
																							wehoAccount.metadata.account_info.sub_domains) *
																					  100
																					: 0
																			}
																			format={(percent) =>
																				wehoAccount.metadata?.resource?.subdom
																					? // WEBUZO format
																					  `${wehoAccount.metadata.resource.subdom.used} / ${
																							wehoAccount.metadata.resource.subdom.limit ===
																							"unlimited"
																								? "∞"
																								: wehoAccount.metadata.resource.subdom.limit
																					  }`
																					: // CWP format
																					  `${
																							wehoAccount.metadata?.account_info
																								?.sub_domains_used || 0
																					  } / ${
																							wehoAccount.metadata?.account_info?.sub_domains || 0
																					  }`
																			}
																		/>
																	</Space>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={12}>
														<Card title={"Domain"} type="inner" style={{ marginBottom: 24 }}>
															{wehoAccount.metadata?.domains &&
															wehoAccount.metadata.domains.length > 0 ? (
																<List
																	size="small"
																	dataSource={wehoAccount.metadata.domains}
																	renderItem={(domain) => (
																		<List.Item>
																			<List.Item.Meta
																				avatar={
																					<PiGlobeDuotone size={20} style={{ color: "#1890ff" }} />
																				}
																				title={domain.domain}
																				description={
																					<div>
																						<div>
																							<Text type="secondary">Path:</Text>{" "}
																							<Text code>{domain.path}</Text>
																						</div>
																						<div>
																							<Text type="secondary">Email:</Text>{" "}
																							<Text>{domain.email}</Text>
																						</div>
																					</div>
																				}
																			/>
																		</List.Item>
																	)}
																/>
															) : (
																<div style={{ textAlign: "center", padding: "20px 0" }}>
																	<Text type="secondary">Tidak ada domain yang dikonfigurasi</Text>
																</div>
															)}
														</Card>
														<Card title={"Basis Data"} type="inner">
															{wehoAccount.metadata?.databases &&
															wehoAccount.metadata.databases.length > 0 ? (
																<List
																	size="small"
																	dataSource={wehoAccount.metadata.databases}
																	renderItem={(database) => (
																		<List.Item>
																			<List.Item.Meta
																				avatar={
																					<PiDatabaseDuotone
																						size={20}
																						style={{ color: "#52c41a" }}
																					/>
																				}
																				title={database.database}
																				description={
																					<div>
																						{database.user && (
																							<div>
																								<Text type="secondary">Pengguna:</Text>{" "}
																								<Text>{database.user}</Text>
																							</div>
																						)}
																						{database.host && (
																							<div>
																								<Text type="secondary">Host:</Text>{" "}
																								<Text>{database.host}</Text>
																							</div>
																						)}
																					</div>
																				}
																			/>
																		</List.Item>
																	)}
																/>
															) : (
																<div style={{ textAlign: "center", padding: "20px 0" }}>
																	<Text type="secondary">
																		Tidak ada basis data yang dikonfigurasi
																	</Text>
																</div>
															)}
														</Card>
													</Col>
												</Row>
											) : (
												<Card>
													<Spin />
												</Card>
											),
									},
								instance &&
									instance.type === "APLA" &&
									instance.service.code === "APLA.AP" && {
										key: "deployments",
										label: (
											<Space>
												<PiCloudArrowUpDuotone />
												Deployment
												{aplaDeployments && aplaDeployments.length > 0 && (
													<Badge count={aplaDeployments.length} />
												)}
											</Space>
										),
										children: (
											<Card title="Deployment Aplikasi" type="inner" style={{ marginBottom: 24 }}>
												{aplaDeployments && aplaDeployments.length > 0 ? (
													<Table
														dataSource={aplaDeployments}
														rowKey="id"
														pagination={false}
														columns={[
															{
																title: "ID",
																dataIndex: "id",
																key: "id",
																width: 70,
																render: (text) => <Text code>{text}</Text>,
															},
															{
																title: "Status",
																dataIndex: "status",
																key: "status",
																width: 100,
																render: (status) => {
																	const getDeploymentStatusColor = (status) => {
																		switch (status?.toLowerCase()) {
																			case "finished":
																			case "success":
																				return "green";
																			case "running":
																			case "in_progress":
																				return "processing";
																			case "failed":
																			case "error":
																				return "red";
																			case "cancelled":
																				return "default";
																			case "queued":
																			case "pending":
																				return "orange";
																			default:
																				return "blue";
																		}
																	};
																	return (
																		<Tag color={getDeploymentStatusColor(status)}>
																			{status?.toUpperCase()}
																		</Tag>
																	);
																},
															},
															{
																title: "Commit",
																dataIndex: "commit",
																key: "commit",
																width: 120,
																render: (commit) => (
																	<Text code copyable={{ text: commit }}>
																		{commit?.substring(0, 7)}
																	</Text>
																),
															},
															{
																title: "Pesan",
																dataIndex: "commit_message",
																key: "commit_message",
																render: (message) => (
																	<Text ellipsis={{ tooltip: message }}>
																		{message || "Tidak ada pesan"}
																	</Text>
																),
															},
															{
																title: "Dimulai",
																dataIndex: "created_at",
																key: "created_at",
																width: 180,
																render: (date) => (
																	<Text>{dayjs(date).format("DD MMM, HH:mm:ss")}</Text>
																),
															},
															{
																title: "Selesai",
																dataIndex: "finished_at",
																key: "finished_at",
																width: 180,
																render: (date) =>
																	date ? (
																		<Text>
																			{dayjs(`${date}.000000Z`).format("DD MMM, HH:mm:ss")}
																		</Text>
																	) : (
																		<Text type="secondary">-</Text>
																	),
															},
															{
																title: "Durasi",
																key: "duration",
																width: 100,
																render: (_, record) => {
																	if (record.finished_at && record.created_at) {
																		const duration = dayjs(`${record.finished_at}.000000Z`).diff(
																			dayjs(record.created_at),
																			"seconds"
																		);
																		const minutes = Math.floor(duration / 60);
																		const seconds = duration % 60;
																		return (
																			<Text>
																				{minutes > 0 && `${minutes}m `}
																				{seconds}s
																			</Text>
																		);
																	}
																	return <Text type="secondary">-</Text>;
																},
															},
															{
																title: "",
																key: "actions",
																render: (_, record) => (
																	<Space>
																		{record.logs && (
																			<Button
																				type="link"
																				size="small"
																				icon={<PiFileTextDuotone />}
																				onClick={() => {
																					Modal.info({
																						title: `Log Deployment - #${record.id}`,
																						width: 1000,
																						content: (
																							<div style={{ maxHeight: "60vh", overflow: "auto" }}>
																								{(() => {
																									try {
																										const logs = JSON.parse(record.logs);
																										return (
																											<Timeline
																												mode="left"
																												items={logs.map((log, index) => ({
																													key: index,
																													color:
																														log.type === "stderr" ? "red" : "blue",
																													children: (
																														<div>
																															{log.command && (
																																<div style={{ marginBottom: 4 }}>
																																	<Text
																																		code
																																		style={{
																																			fontSize: "11px",
																																			backgroundColor: "#f0f2f5",
																																		}}>
																																		$ {log.command}
																																	</Text>
																																</div>
																															)}
																															<div style={{ marginBottom: 4 }}>
																																<Text
																																	style={{
																																		fontSize: "12px",
																																		fontFamily: "monospace",
																																		whiteSpace: "pre-wrap",
																																		// color:
																																		// 	log.type === "stderr"
																																		// 		? "#ff4d4f"
																																		// 		: "inherit",
																																	}}>
																																	{log.output}
																																</Text>
																															</div>
																															<div>
																																<Text
																																	type="secondary"
																																	style={{ fontSize: "10px" }}>
																																	{dayjs(log.timestamp).format(
																																		"HH:mm:ss.SSS"
																																	)}{" "}
																																	- {log.type}
																																</Text>
																															</div>
																														</div>
																													),
																												}))}
																											/>
																										);
																									} catch (e) {
																										return (
																											<pre
																												style={{
																													fontSize: "12px",
																													whiteSpace: "pre-wrap",
																													backgroundColor: "#f5f5f5",
																													padding: "12px",
																													borderRadius: "4px",
																												}}>
																												{record.logs}
																											</pre>
																										);
																									}
																								})()}
																							</div>
																						),
																					});
																				}}></Button>
																		)}
																	</Space>
																),
															},
														]}
													/>
												) : (
													<div style={{ textAlign: "center", padding: "40px 0" }}>
														<PiCloudArrowUpDuotone size={48} style={{ color: "#d9d9d9" }} />
														<div style={{ marginTop: 16 }}>
															<Text type="secondary">Tidak ada deployment</Text>
														</div>
													</div>
												)}
											</Card>
										),
									},
								instance &&
									instance.type === "APLA" &&
									instance.service.code === "APLA.AP" && {
										key: "logs",
										label: (
											<Space>
												<PiFileTextDuotone />
												Log
											</Space>
										),
										children: (
											<Card
												title="Log APLA"
												type="inner"
												style={{ marginBottom: 24 }}
												extra={
													<Button
														type="default"
														icon={<PiArrowDownDuotone />}
														onClick={() =>
															aplaLogsRef.current?.scrollTo({
																top: aplaLogsRef.current.scrollHeight,
																behavior: "smooth",
															})
														}>
														Gulir ke Bawah
													</Button>
												}>
												<div ref={aplaLogsRef} style={{ maxHeight: "400px", overflowY: "auto" }}>
													<pre
														style={{
															margin: 0,
															fontSize: "12px",
															whiteSpace: "pre-wrap",
															backgroundColor: "#f5f5f5",
															padding: "16px",
															borderRadius: "6px",
														}}>
														{aplaLogs && aplaLogs.length > 0 ? (
															<>
																{aplaLogs.split("\n").map((line, index) => (
																	<div key={index}>&gt; {line}</div>
																))}
															</>
														) : (
															<div>Memuat log...</div>
														)}
													</pre>
												</div>
											</Card>
										),
									},
								{
									key: "settings",
									label: (
										<Space>
											<PiGearDuotone />
											<span>Pengaturan</span>
										</Space>
									),
									children: (
										<Tabs
											type="card"
											tabPosition="left"
											// className="no-margin-tabs"
											items={[
												{
													key: "general",
													label: (
														<Space>
															<span>Umum</span>
														</Space>
													),
													// instance have name and description, it can be edited here
													children: (
														<Card title="Pengaturan Umum" type="inner" style={{ marginBottom: 24 }}>
															{instance && instance.type === "APLA" ? (
																<Form
																	layout="vertical"
																	form={generalAPLAInfoForm}
																	onFinish={handleUpdateAPLAApplication}>
																	<Form.Item
																		label="Nama"
																		name="name"
																		rules={[{ required: true, message: "Silakan masukkan nama" }]}>
																		<Input />
																	</Form.Item>
																	<Form.Item
																		label="Deskripsi"
																		name="description"
																		rules={[
																			{ required: true, message: "Silakan masukkan deskripsi" },
																		]}>
																		<Input.TextArea rows={4} />
																	</Form.Item>
																	<Form.Item style={{ marginBottom: 8 }}>
																		<Button type="primary" htmlType="submit">
																			Simpan
																		</Button>
																	</Form.Item>
																</Form>
															) : (
																<Empty
																	image={Empty.PRESENTED_IMAGE_SIMPLE}
																	description="Tidak ada pengaturan umum untuk layanan ini"
																/>
															)}
														</Card>
													),
												},
												instance &&
													instance.type === "APLA" &&
													instance.service.code === "APLA.AP" && {
														key: "domains",
														label: (
															<Space>
																<span>Domain</span>
															</Space>
														),
														children: (
															<Card
																title="Manajemen Domain"
																type="inner"
																style={{ marginBottom: 24 }}
																extra={
																	<Button
																		type="primary"
																		icon={<PiPlusDuotone />}
																		onClick={() => setAddDomainModalVisible(true)}
																		loading={updateDomainsLoading}>
																		Tambah Domain
																	</Button>
																}>
																{aplaDomains && aplaDomains.length > 0 ? (
																	<List
																		dataSource={aplaDomains}
																		renderItem={(domain, index) => (
																			<List.Item
																				key={index}
																				actions={[
																					<Popconfirm
																						title="Hapus Domain"
																						description={`Yakin ingin menghapus domain ${domain}?`}
																						onConfirm={() => handleRemoveDomain(domain)}
																						okText="Ya, Hapus"
																						cancelText="Batal"
																						placement="topRight"
																						key="delete">
																						<Button
																							type="text"
																							danger
																							disabled={domain.includes(
																								aplaApplication.metadata.uuid
																							)}
																							icon={<PiTrashDuotone />}
																							loading={updateDomainsLoading}>
																							Hapus
																						</Button>
																					</Popconfirm>,
																				]}>
																				<List.Item.Meta
																					avatar={
																						<PiGlobeDuotone
																							style={{ fontSize: 20, color: "#01abe9" }}
																						/>
																					}
																					title={
																						<Text copyable={{ text: domain }}>
																							{domain}
																							{domain.includes(aplaApplication.metadata.uuid) && (
																								<Tag style={{ marginLeft: 8 }} color="blue">
																									Domain Utama
																								</Tag>
																							)}
																						</Text>
																					}
																					description={
																						<Space>
																							<Tag color="green">Aktif</Tag>
																							<Text type="secondary">Domain aplikasi APLA</Text>
																						</Space>
																					}
																				/>
																			</List.Item>
																		)}
																	/>
																) : (
																	<Empty
																		image={
																			<PiGlobeDuotone style={{ fontSize: 48, color: "#d9d9d9" }} />
																		}
																		description="Belum ada domain yang dikonfigurasi">
																		<Button
																			type="primary"
																			icon={<PiPlusDuotone />}
																			onClick={() => setAddDomainModalVisible(true)}>
																			Tambah Domain Pertama
																		</Button>
																	</Empty>
																)}
															</Card>
														),
													},
												instance &&
													instance.type === "APLA" &&
													instance.service.code === "APLA.AP" && {
														key: "environments",
														label: (
															<Space>
																<span>Variabel Environment</span>
															</Space>
														),
														children: (
															<Card
																title="Variabel Environment"
																type="inner"
																style={{ marginBottom: 24 }}
																extra={
																	<Button
																		type="primary"
																		icon={<PiPlusDuotone />}
																		onClick={handleCreateEnvironment}>
																		Tambah Variabel
																	</Button>
																}>
																{aplaEnvironments && aplaEnvironments.length > 0 ? (
																	<Space direction="vertical" style={{ width: "100%" }}>
																		<Divider orientation="left" orientationMargin={0} plain>
																			<strong>Production Environment</strong>
																		</Divider>
																		{aplaEnvironments
																			.filter((env) => env.is_preview === false)
																			.map((env) => (
																				<div
																					key={env.uuid}
																					style={{
																						width: "100%",
																						display: "flex",
																						alignItems: "center",
																						gap: "8px",
																					}}>
																					<div style={{ minWidth: "200px" }}>
																						<Input
																							value={env.key}
																							style={{ width: "100%" }}
																							onChange={(e) =>
																								handleEnvironmentChange(
																									env.uuid,
																									"key",
																									e.target.value
																								)
																							}
																						/>
																					</div>
																					<div style={{ flex: 1 }}>
																						<Input
																							value={env.value}
																							style={{ width: "100%" }}
																							onChange={(e) =>
																								handleEnvironmentChange(
																									env.uuid,
																									"value",
																									e.target.value
																								)
																							}
																						/>
																					</div>
																					<Popconfirm
																						title="Yakin ingin menghapus lingkungan ini?"
																						onConfirm={() =>
																							handleDeleteEnvironmentSubmit(env.uuid)
																						}>
																						<Button type="text" danger icon={<PiTrashDuotone />} />
																					</Popconfirm>
																				</div>
																			))}
																		<Divider orientation="left" orientationMargin={0} plain>
																			<strong>Preview Environment</strong>
																		</Divider>
																		{aplaEnvironments
																			.filter((env) => env.is_preview === true)
																			.map((env) => (
																				<div
																					key={env.uuid}
																					style={{
																						width: "100%",
																						display: "flex",
																						alignItems: "center",
																						gap: "8px",
																					}}>
																					<div style={{ minWidth: "200px" }}>
																						<Input
																							value={env.key}
																							style={{ width: "100%" }}
																							onChange={(e) =>
																								handleEnvironmentChange(
																									env.uuid,
																									"key",
																									e.target.value
																								)
																							}
																						/>
																					</div>
																					<div style={{ flex: 1 }}>
																						<Input
																							value={env.value}
																							style={{ width: "100%" }}
																							onChange={(e) =>
																								handleEnvironmentChange(
																									env.uuid,
																									"value",
																									e.target.value
																								)
																							}
																						/>
																					</div>
																					<Popconfirm
																						title="Yakin ingin menghapus lingkungan ini?"
																						onConfirm={() =>
																							handleDeleteEnvironmentSubmit(env.uuid)
																						}>
																						<Button type="text" danger icon={<PiTrashDuotone />} />
																					</Popconfirm>
																				</div>
																			))}
																		<Button
																			type="primary"
																			onClick={handleUpdateEnvironmentSubmit}
																			style={{ width: "100%", marginTop: 16 }}>
																			Simpan Environment
																		</Button>
																	</Space>
																) : (
																	<div style={{ textAlign: "center", padding: "20px 0" }}>
																		<Text type="secondary">
																			Tidak ada lingkungan yang dikonfigurasi
																		</Text>
																	</div>
																)}
															</Card>
														),
													},
												{
													key: "metadata",
													label: <Space>Metadata</Space>,
													children: (
														<Card
															title="Metadata"
															type="inner"
															style={{ marginBottom: 24 }}
															// extra={
															// 	<Button
															// 		type="default"
															// 		icon={<PiPencilDuotone />}
															// 		onClick={handleEditMetadata}>
															// 		Edit Metadata
															// 	</Button>
															// }
														>
															{instance.metadata && Object.keys(instance.metadata).length > 0 ? (
																<div
																	style={{
																		backgroundColor: "#f5f5f5",
																		padding: "16px",
																		borderRadius: "6px",
																	}}>
																	<pre
																		style={{ margin: 0, fontSize: "12px", wordWrap: "break-word" }}>
																		{JSON.stringify(instance.metadata, null, 2)}
																	</pre>
																</div>
															) : (
																<Empty
																	image={Empty.PRESENTED_IMAGE_SIMPLE}
																	description="Tidak ada metadata yang tersedia"
																/>
															)}
														</Card>
													),
												},
											]}
										/>
									),
								},
							]}
						/>
					</Col>
				</Row>
			</div>

			{/* Create Environment Modal */}
			<Modal
				title={
					<Space>
						<PiPencilDuotone />
						<span>Tambah Variabel Environment Baru</span>
					</Space>
				}
				open={createEnvironmentModalVisible}
				onCancel={handleCreateEnvironmentCancel}
				width={512}
				footer={null}>
				<Form
					form={createEnvironmentForm}
					layout="vertical"
					onFinish={handleCreateEnvironmentSubmit}>
					<Form.Item
						label="Kunci"
						name="key"
						rules={[{ required: true, message: "Silakan masukkan kunci lingkungan" }]}>
						<Input placeholder="Masukkan kunci lingkungan" />
					</Form.Item>
					<Form.Item
						label="Nilai"
						name="value"
						rules={[{ required: true, message: "Silakan masukkan nilai lingkungan" }]}>
						<Input.TextArea rows={4} placeholder="Masukkan nilai lingkungan" />
					</Form.Item>
					<Form.Item name="isPreview" valuePropName="checked" style={{ marginBottom: 0 }}>
						<Checkbox>Hanya untuk lingkungan pratinjau</Checkbox>
					</Form.Item>

					<Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
						<Space style={{ width: "100%", justifyContent: "flex-end" }}>
							<Button onClick={handleCreateEnvironmentCancel}>Batal</Button>
							<Button type="primary" htmlType="submit" loading={createEnvironmentLoading}>
								Kirim
							</Button>
						</Space>
					</Form.Item>
				</Form>
			</Modal>

			{/* Add Domain Modal */}
			<Modal
				title={
					<Space>
						<PiGlobeDuotone />
						<span>Tambah Domain Baru</span>
					</Space>
				}
				open={addDomainModalVisible}
				onCancel={() => {
					setAddDomainModalVisible(false);
					domainForm.resetFields();
				}}
				width={512}
				footer={null}>
				<Form form={domainForm} layout="vertical" onFinish={handleAddDomain}>
					<Form.Item
						label="Domain"
						name="domain"
						rules={[
							{ required: true, message: "Silakan masukkan domain" },
							{
								pattern: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
								message: "Format domain tidak valid",
							},
						]}
						extra="Domain akan secara otomatis diawali dengan https:// jika tidak disertakan">
						<Input
							placeholder="contoh: mydomain.com atau https://mydomain.com"
							prefix={<PiGlobeDuotone style={{ color: "#01abe9" }} />}
						/>
					</Form.Item>

					<Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
						<Space style={{ width: "100%", justifyContent: "flex-end" }}>
							<Button
								onClick={() => {
									setAddDomainModalVisible(false);
									domainForm.resetFields();
								}}>
								Batal
							</Button>
							<Button type="primary" htmlType="submit" loading={updateDomainsLoading}>
								Tambah Domain
							</Button>
						</Space>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
}

export default InstanceViewPage;
